import { createFileRoute } from "@tanstack/react-router";
import { PageHeading } from "@/ui";
import { ConsentStates } from "#/components/subscribers/ConsentStates";
import { GrowthChannels } from "#/components/subscribers/GrowthChannels";
import { ImportSubscribersDialog } from "#/components/subscribers/ImportSubscribersDialog";
import { SubscribersTable } from "#/components/subscribers/SubscribersTable";

// Subscribers (#592, was `/emails`). v2-restyled per #595. The manual Refresh
// control was removed as product feedback — `SubscribersTable` and
// `ConsentStates` both poll on a 30s interval and refetch on window focus
// instead. `SubscribersTable` takes both from `listFetchPolicy`, which switches
// them off past `MAX_AUTO_REFETCH_PAGES`; that depth carries its own notice and
// a manual refresh, so the removal above is not what leaves a deep list still.
export const Route = createFileRoute("/dashboard/w/$workspaceId/subscribers/")({
  component: SubscribersPage,
});

function SubscribersPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      <PageHeading
        title="Subscribers"
        lede="Only emails with granted consent are eligible to receive communications from your domain."
        action={<ImportSubscribersDialog workspaceId={workspaceId} />}
      />

      <ConsentStates workspaceId={workspaceId} />

      {/*
        Single column until `lg`: below that the table and the Growth-channels
        panel would each be squeezed under their own content width, and the
        table already scrolls horizontally inside its own wrapper.
      */}
      <div className="grid grid-cols-1 items-start gap-6 lg:[grid-template-columns:minmax(0,2fr)_minmax(280px,1fr)]">
        <SubscribersTable workspaceId={workspaceId} />
        <GrowthChannels workspaceId={workspaceId} />
      </div>
    </div>
  );
}
